(ns practitest.frontend.stacked-bar-chart
  (:require [practitest.frontend.common.utils :as utils]
            [practitest.frontend.init :as init]
            [practitest.frontend.components2.dashboard.chart :as chart]))

(defn root-view [{:keys [data-item-id data-edit-url]}]
  [chart/chart #:chart{:id       (js/Number data-item-id)
                       :type     ::chart/stacked-bar
                       :edit-url data-edit-url}])

(defn ^:dev/after-load remount-roots []
  (init/remount-roots "stacked-bar-chart-component" root-view))

(utils/register-webcomponent! "stacked-bar-chart-component")